import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import * as resActions from "../../modules/resources";
import Loader from "Components/loader/Loader";
import withAutoRefresh from "Components/withAutoRefresh";
import { displayFormattedDate } from "Utils/dateFormats";
import PropTypes from "prop-types";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";
import { Icon, settings } from "Icons/index";

import ButtonBack from "Components/buttonBack/ButtonBack";
import DetailStatus from "Components/detailStatus/DetailStatus";
import DetailInfo from "Components/detailInfo/DetailInfo";

import cx from "classnames";
import s from "./showArchive.scss";

const propTypes = {};

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

class ArchiveDomainShowScreen extends React.Component {
  constructor(props) {
    super(props);
    this.showSettings = this.showSettings.bind(this);
    this.showArchiveEmails = this.showArchiveEmails.bind(this);
    this.goBack = this.goBack.bind(this);

    this.state = {
      customer_code: undefined,
      showInfo: this.props.isMediaMobile ? false : true,
    };

    this.toggleInfo = this.toggleInfo.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.getDomain(this.props.match.params.domainCode);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMediaMobile !== this.props.isMediaMobile) {
      this.setState({
        showInfo: this.props.isMediaMobile ? false : true,
      });
    }
  }

  showSettings() {
    this.props.history.push({
      pathname: `/archive/domains/${this.props.match.params.domainCode}/settings`,
    });
  }

  showArchiveEmails() {
    this.props.history.push({
      pathname: `/archive/domains/${this.props.match.params.domainCode}/email_accounts`,
    });
  }

  toggleInfo() {
    this.setState({ showInfo: !this.state.showInfo });
  }

  renderTabs() {
    let parts = this.props.location.pathname.split("/");
    const currentSection = parts[parts.length - 1];
    const {
      getLoggedUserType,
      isMobileDevice,
      isMediaMobile,
      isMediaSM,
      isMediaMD,
      isMediaLG,
    } = this.context;

    return (
      <div className={s.scrollTabs}>
        <div className={s.tabs}>
          <div
            className={cx(s.itemTabs, { [s.active]: currentSection === "email_accounts" })}
            onClick={this.showArchiveEmails}
          >
            {t("tab.emailArchive")}
          </div>

          <div
            className={cx(s.itemTabs, {
              [s.active]: currentSection === "settings",
            })}
            onClick={this.showSettings}
          >
            <Icon className={s.iconTabs} svg={settings} width="0.75rem" height="0.75rem" />
            {t("tab.settings")}
          </div>
        </div>
      </div>
    );
  }

  goBack() {
    const { location } = this.props;
    const query = _.get(location, "state.prevPagination", "");
    this.props.history.push("/archive" + query);
  }

  render() {
    const { domain, isDomainLoading } = this.props;

    const { showInfo } = this.state;

    const {
      getLoggedUserType,
      isMobileDevice,
      isMediaMobile,
      isMediaSM,
      isMediaMD,
      isMediaLG,
    } = this.context;

    if (isDomainLoading || !domain) {
      return <Loader {...this.props} />;
    }
    return (
      <div className={s.showArchive}>
        <div className={s.navigation}>
          <ButtonBack onClick={this.goBack} />

          <div className={s.viewSectionLabel}>{t("section.view.archive.domain")}</div>
        </div>

        <div className={s.header}>
          <div className={s.wrapTitle}>
            <div className="sectionTitle">{domain.name}</div>

            {isMediaMobile() && (
              <div className="internalLink" onClick={this.toggleInfo}>
                {showInfo ? t("button.details.hide") : t("button.details.show")}
              </div>
            )}
          </div>

          {showInfo && (
            <div className={s.subtitle}>
              <DetailStatus status={domain.archive_status} />
              {domain.manager_fullname && (
                <div className="sectionDesc">{domain.manager_fullname}</div>
              )}
            </div>
          )}

          {showInfo && (
            <div className={s.info}>
              <DetailInfo label={t("detailInfo.label.code")} info={domain.code} inLine />
              <DetailInfo
                label={t("detailInfo.label.created")}
                info={displayFormattedDate(domain.archive_activated_at)}
                inLine
              />
              <DetailInfo label={t("detailInfo.label.storage")} info={domain.company} inLine />
              <DetailInfo label={t("detailInfo.label.storageOnNew")} info={domain.company} inLine />
            </div>
          )}
        </div>

        <div className={s.settings}>
          {domain.status !== "failure" && getLoggedUserType() !== "Postmaster" && this.renderTabs()}

          {React.cloneElement(this.props.children, {
            ...this.props,
            loggedUser: this.context.getLoggedUser(),
          })}
        </div>
      </div>
    );
  }
}

//ArchiveDomainShowScreen.propTypes = propTypes;
ArchiveDomainShowScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  domain: resActions.getData("domain.data", state)[0],
  isDomainLoading: resActions.isResourceLoading("domain", state),
  archiveDomains: resActions.getData("archiveDomains.data", state),
  domainsTotals: resActions.getData("archiveDomains.paginationInfo.totals", state),
  paginationInfo: resActions.getData("archiveDomains.paginationInfo", state),
  areDomainsLoading: resActions.isResourceLoading("archiveDomains", state),
});

const mapDispatchToProps = (dispatch) => ({
  getDomain: (code) => dispatch(resActions.callApi("getDomain", "domain", code)),
  getDomainsTotals: () => dispatch(resActions.callApi("getDomainsTotals", "domainsTotals")),
  retrievePagination: (queryParams) =>
    dispatch(resActions.callApi("getDomains", "domains", queryParams)),
  refreshDomains: (queryParams) =>
    dispatch(resActions.callApi("refreshDomains", "domains", queryParams)),
  deleteDomain: (code) => dispatch(resActions.callApi("deleteDomain", "domains", code)),
  changeDomainStatus: (code, status) =>
    dispatch(resActions.callApi("changeDomainStatus", "domain", code, status)),
  changeStatus: (resourceCode, newValue) =>
    dispatch(
      resActions.changeAttribute(newValue, {
        resourcesType: "domains",
        resourceCode,
        resourceAttribute: "status",
      })
    ),
  changeStatusDetail: (resourceCode, newValue) =>
    dispatch(
      resActions.changeAttribute(newValue, {
        resourcesType: "domains",
        resourceCode,
        resourceAttribute: "status_detail",
      })
    ),
});

const refreshConditionFunc = (props) => {
  const statuses = ["activating", "disabling", "enabling", "deleting", "updating"];
  const enqueued = _.filter(
    props.domains,
    (d) =>
      statuses.includes(d.status) ||
      (d.status === "ownership_check" && d.status_detail === "verifying")
  );
  return enqueued.length > 0 && !props.areDomainsLoading;
};

const onRefreshFunc = (props) => {
  props.refreshDomains(props.location.search);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAutoRefresh(ArchiveDomainShowScreen, refreshConditionFunc, onRefreshFunc));
